/**
 * @generated SignedSource<<80c8b12766024e51f8b54cd86fb9eeff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoWrapper_item$data = {
  readonly defaultSkuId: string | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingAndReturns_item">;
  readonly " $fragmentType": "PdpSharedShippingInfoWrapper_item";
};
export type PdpSharedShippingInfoWrapper_item$key = {
  readonly " $data"?: PdpSharedShippingInfoWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultSkuId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingAndReturns_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "ae0b3ab3d4ae58f37c36a27e066ca481";

export default node;
